import { StorePaymentLogGetRequestOrderEnum } from "../api/main";
import { PaymentOrder } from "../store/slice/logSlice";

export const paymentOrderEnumConverter = (order: PaymentOrder): StorePaymentLogGetRequestOrderEnum => {
  switch (order) {
    case 'asc': return StorePaymentLogGetRequestOrderEnum.Asc;
    case 'desc': return StorePaymentLogGetRequestOrderEnum.Desc;
    default: return StorePaymentLogGetRequestOrderEnum.Asc;
  }
}